import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type TwitchIconProps = React.ComponentPropsWithRef<'svg'>;

export function TwitchIcon({ ...restProps }: TwitchIconProps) {
    const { isDarkMode } = useDarkMode();

    if (isDarkMode()) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <path
                    d="M11.571 4.714H13.286V9.857H11.57L11.571 4.714ZM16.286 4.714H18V9.857H16.286V4.714ZM6 0L1.714 4.286V19.714H6.857V24L11.143 19.714H14.571L22.286 12V0H6ZM20.571 11.143L17.143 14.571H13.714L10.714 17.571V14.571H6.857V1.714H20.571V11.143Z"
                    fill="white"
                />
            </svg>
        );
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <path
                d="M11.571 4.714H13.286V9.857H11.57L11.571 4.714ZM16.286 4.714H18V9.857H16.286V4.714ZM6 0L1.714 4.286V19.714H6.857V24L11.143 19.714H14.571L22.286 12V0H6ZM20.571 11.143L17.143 14.571H13.714L10.714 17.571V14.571H6.857V1.714H20.571V11.143Z"
                fill="#9146FF"
            />
        </svg>
    );
}
